import {
  NEW_NOTIFICATION,
  GET_NEXT_NOTIFICATION,
  EMPTY_CURRENT_NOTIFICATION,
  ADD_NEW,
  GET_NEXT,
  EMPTY_CURRENT
} from "./constants.js";

const regex = /^(notifications\/)/;

const _NEW_NOTIFICATION = NEW_NOTIFICATION.replace(regex, "");
const _GET_NEXT_NOTIFICATION = GET_NEXT_NOTIFICATION.replace(regex, "");
const _EMPTY_CURRENT_NOTIFICATION = EMPTY_CURRENT_NOTIFICATION.replace(
  regex,
  ""
);

export default {
  [_NEW_NOTIFICATION]({ commit }, { message, priority }) {
    commit(ADD_NEW, { message, priority });
  },
  [_GET_NEXT_NOTIFICATION]({ commit }) {
    commit(GET_NEXT);
  },
  [_EMPTY_CURRENT_NOTIFICATION]({ commit }) {
    commit(EMPTY_CURRENT);
  }
};
